<template>
  <div class="item-inner specal">
    <div class="item-title label" style="width: 60%; color: #8e8e93;">{{this.attribute.label}}</div>
    <div class="item-after guding" style="border:1px solid #e7e7e7"> <div class="item-input">
      <input class="pb-standalone" type="text" style="font-size: .6rem;text-align: center;color: rgb(8, 148, 236) " @click="gototlno" value="查看载体图谱"     readonly="readonly" >
    </div>
      <!--<span class="icon icon-down" style="margin-top:.2rem;margin-right: .5rem;color: gray "></span>-->
    </div></div>



</template>
<script>
  import $ from 'jquery'
  export default {
    name: 'finder-attr-text-box',
    data () {
      return {
        questionUrl: '/emktResources/resocurces/img/question.png',
        attrurl: '/emktResources/resocurces/img/promotion/SKUIMG/'
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup'
    ],
    mounted () {
    },
    created () {

    },
    computed: {
    },
    methods: {
      control () {
      },
      close: function () {
        this.$emit('close')
      },
      gototlno () {
//        var url = this.attrurl + this.attribute.valueText.TLNo + '.jpg'
//        var myPhotoBrowserStandalone = $.photoBrowser({
//          photos: [url]
//        })
//        $(document).on('click', '.pb-standalone', function () {
//          myPhotoBrowserStandalone.open()
//        })
        var tlno = ''
        if (this.attribute.valueText.TLNo) {
          tlno = this.attribute.valueText.TLNo
        } else {
          tlno = this.attribute.value
        }
        var content = '<div id="lottery"><img style="width: 13.5rem;height: 14rem;"' + 'src=' + this.attrurl + tlno + '.jpg' + '></div>'
        $.modal({
          text: content,
          buttons: [ {
            text: '确定',
            onClick: function () {
            }
          }]
        })
        $('.modal').css({'width': '15rem', 'height': '18rem', 'margin-left': '-7.7rem'})
        $('.modal-buttons').css({'height': '1.5rem'})
        $('.modal-button').css({'line-height': '1.5rem'})
        $('.modal-inner').css({'padding': '.55rem'})
      }
    },
    watch: {
      'attribute.value': function (val) {
        this.attribute.valueText = val
      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .modal{
    width: 17rem;
    height: 17rem;
    margin-top: 1rem;
    margin-left: 0rem;
  }
  .specal {
    border-bottom: 0px solid;
  }
  .checkbox-el {
    display: inline-block;
    text-align: left;
  }
  .options {
    color: grey;
    font-size: .6rem;
    width: 120px;
    margin-left: .3rem;
  }
  .item-content {
    padding-left: .2rem
  }
  .item-title {
    font-size: 0.6rem;
    color: black;
  }
  .guding {
    width: 140px;
  }
  .item-after {
    font-size: 0.6rem;
    color: black;
  }

  .gotopay{
    position: absolute;
    right: 0;
    background-color: #00469A;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    height: 3rem;}
  .gotopay_button_style{
  @include sc(.7rem, #F6383A);
    font-weight: bold;
    color: #fff;

  }
  .button.active {
    z-index: 100;
    color: #00469A;
    background-color: white;
    border-bottom: 1px solid
  }
  .tab-link.button {
    border: 0px solid black;
    color: gray;
    border-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// FinderAttrTVBox.vue?98ab2fbe